import React, {Component} from "react";
import {connect} from "react-redux";
import ClusterGroupTabs from "../../blocks/ClusterGroupTabs";
import SVGImage from "../../svg/SVGImage";

class CommunitiesPriorities extends Component {

  render() {
    const {baseUrl} = this.props;
    return (
      <div className="fow-row">
        <div className="fow-col-1">
          <ClusterGroupTabs>
            <div style={{height: "100%"}}>
              <SVGImage src={`${baseUrl}home/local-communities-dgh.svg`} />
            </div>
            <div style={{height: "100%"}}>
              <SVGImage src={`${baseUrl}home/local-communities-se.svg`} />
            </div>
            <div style={{height: "100%"}}>
              <SVGImage src={`${baseUrl}home/local-communities-sr.svg`} />
            </div>
          </ClusterGroupTabs>
          <div style={{height:60}}>
            <SVGImage src={`${baseUrl}home/local-communities-legend.svg`} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    baseUrl: state.settings.baseUrl,
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CommunitiesPriorities);
